
import './end_point.css'; // Styles CSS pour l'application
import Endpoint from './end_point';

const Documentation = () => {
  return (
    <div className="documentation p-5">
      <header>
        <h1>Documentation de l'API Seremo</h1>
        <p>Bienvenue dans la documentation de l'API Seremo. Cette API permet d'intégrer des fonctionnalités de paiement via la passerelle Seremo dans vos applications.</p>
      </header>

      <main>
        <Endpoint
          name="payIn"
          description="Effectue une transaction de paiement via la passerelle Seremo."
          url="POST https://my-api.seremo.com/api/v2/payIn"
          parameters={[
            { name: 'api_key', type: 'string', description: 'Clé d\'API de l\'utilisateur pour l\'authentification.' },
            { name: 'transaction_id', type: 'string', description: 'ID de transaction pour identifier la transaction.' },
            { name: 'rMt', type: 'float', description: 'Montant de la transaction.' },
            { name: 'rN', type: 'string', description: 'Nom du destinataire ou motif du paiement (optionnel).' },
            { name: 'locale', type: 'string', description: 'Locale pour la langue de la réponse (par défaut \'fr\').' }
          ]}
          exampleRequest={{
            api_key: 'your_api_key_here',
            transaction_id: '123456',
            rMt: 100.0,
            rN: 'Payment for services',
            locale: 'en'
          }}
          exampleResponseSuccess={{
            status: 'success',
            message: 'Payment successfully processed.',
            transaction_details: {
              transaction_id: '123456',
              amount: 100.0,
              status: 'PROCESSED'
            }
          }}
          exampleResponseError={{
            status: 'error',
            message: 'La requête a échoué. Code de statut 400',
            errors: {
              rMt: ['Le champ rMt est requis.']
            }
          }}
        />
        {/* Ajoutez d'autres endpoints ici si nécessaire */}
      </main>

      <footer>
        <p>© 2024 Seremo. Tous droits réservés.</p>
      </footer>
    </div>
  );
};

export default Documentation;
